'use client';

import React from 'react';
import { GenInternalLink } from '@/components/generics';
import { trackClickEvent } from '@/components/account/ErcSchedule/utils';
import { CTA_NAMES } from '@/utils/rudderstack';
import { LOCAL_STORAGE_KEYS } from '@/constants/localStorage';

export interface OrderDetailsTableProps {
  label: string;
  shippingOriginalUuid: string;
}

const EditAddressButton = ({
  label,
  shippingOriginalUuid,
}: OrderDetailsTableProps) => {
  const handleClick = () => {
    trackClickEvent(CTA_NAMES.EDIT_SHIPPING_ADDRESS);

    window.localStorage.setItem(
      LOCAL_STORAGE_KEYS.editShippingAddressRedirectUrl,
      window.location.pathname,
    );
  };

  return (
    <GenInternalLink
      href={`/account/early-reader-club/edit-shipping-address/${shippingOriginalUuid}`}
      cta={label}
      onClick={handleClick}
    />
  );
};

export default EditAddressButton;
